$( document ).ready(function() {
    $('.tabs__tab').addClass('disabled');
    $('#main_pod_player_parent').addClass('sticky');
    $('.seek_pod_segment').click(function (e) {
        handleSentenceClick($(this).attr('id').match(/\d+/), $(this).attr('id'), e);
    });
    $(document).on("click", ".pod-play-icon" , function(event) {
        handleTooltipClick($(event.target).attr('data-transcript-time'));
    });
    $(document).on("click", ".pod-pause-icon" , function(event) {
        pausePlayer();
    });
    $(document).on("click", ".pod-comment-area" , function(event) {
        swal({
            title: "Sorry",
            text: "You must be signed in to leave a comment",
            type: "warning",
            timer: 2000,
            showConfirmButton: false
        });
    })
    if (window.scroll_to_words) {
        // console.log(window.search_type);
        document.getElementsByClassName("found-search")[0].scrollIntoView({ behavior: "smooth", block: "center", inline: "nearest" });
    }

    document.getElementById('main_pod_player').addEventListener("timeupdate", (event) => {
        //console.log("The currentTime attribute has been updated. Again.");
        updateCurrentPlayTime();
    });

    function waitForElement(callback, tries = 0) {
        let num_ran = 0;
        const interval = setInterval(() => {
            const element = document.getElementById('adhesion_desktop_wrapper');
            const element_modile = document.getElementById('adhesion_mobile_wrapper');
            if (element !== null || element_modile !== null || num_ran >= tries ) {
                clearInterval(interval);
                callback();
            }
            num_ran++;
        }, 1000);
    }

    // Usage
    waitForElement((element) => {
        if (document.getElementById('adhesion_desktop_wrapper') !== null || document.getElementById('adhesion_mobile_wrapper') !== null) {
            if (document.getElementById('adhesion_mobile_wrapper') !== null) {
                setTimeout(function(){
                    document.getElementById('main_pod_player_parent').style.bottom = (document.getElementById('adhesion_mobile_wrapper').offsetHeight + 10)+'px';
                }, 2500);
            } else if (document.getElementById('adhesion_desktop_wrapper') !== null) {
                setTimeout(function(){
                    document.getElementById('main_pod_player_parent').style.bottom = (document.getElementById('adhesion_desktop_wrapper').offsetHeight + 10)+'px';
                }, 2500);
            }
        }
    }, 10);

});


function handleSentenceClick(curr_time, to_div, event) {
    $('.tooltip-expanded').remove();
    var tooltip = '<span class="tooltip-expanded tooltip-expanded-active"><span class="pod-play-icon"><i data-transcript-time="'+curr_time+'" aria-hidden="true" class="fa fa-play"></i></span> <span class="pod-comment-area"><i aria-hidden="true" class="fa fa-commenting"></i></span></span>';
    $('#'+to_div).append(tooltip);
    let sent_width = (event.currentTarget.offsetWidth / 2);
    if (typeof event.currentTarget.querySelector('.tooltip-expanded') !== 'undefined' && event.currentTarget.offsetLeft > sent_width) {
        event.currentTarget.querySelector('.tooltip-expanded').style.left = 'auto';
        event.currentTarget.querySelector('.tooltip-expanded').style.right = '10px';
    }
}
function pausePlayer() {
    var pause_html = '<span class="pod-pause-icon" v-if="isPlaying"><i class="fa fa-pause" aria-hidden="true"></i></span>';
    document.getElementById('main_pod_player').pause();
    $('.pod-pause-icon').remove();
}
function handleTooltipClick(curr_time) {
    document.getElementById('main_pod_player').currentTime = curr_time;
    document.getElementById('main_pod_player').play();
    var pause_html = '<span class="pod-pause-icon" v-if="isPlaying"><i class="fa fa-pause" aria-hidden="true"></i></span>';
    $('.pod-play-icon').after(pause_html);
}
function updateCurrentPlayTime() {
    var current_segment_playing = Math.round(document.getElementById('main_pod_player').currentTime);
    if(document.getElementById("sentenceid_"+current_segment_playing)) {
        let elems = document.querySelectorAll(".seek_pod_segment");
        [].forEach.call(elems, function(el) {
            el.classList.remove("currently-playing");
        });
        document.getElementById("sentenceid_"+current_segment_playing).classList.add('currently-playing');
    }
}
